import getThemeColors from './getThemeColors';

const applySCSSTheme = () => {
  const theme = getThemeColors();
  const appName = process.env.REACT_APP_NAME || 'data2go';

  for (const [key, value] of Object.entries(theme)) {
    document.documentElement.style.setProperty(`--${key.replace(/_/g, '-').toLowerCase()}`, value);
  }

  document.body.className = document.body.className
    .split(' ')
    .filter(cls => !cls.startsWith('theme-'))
    .concat(`theme-${appName}`)
    .join(' ');
};

export default applySCSSTheme;